module.exports = __webpack_public_path__ + "img/ar09.a918c6b6.jpg";